import React from 'react';
import PropTypes from 'prop-types';
import { ButtonGroup, DialogFooter, Divider } from '@zillow/constellation';
import CancelButton from './CancelButton';
import NextButton from './NextButton';
import { useWizard } from '@zillow/zrs-rental-applications';
import { SUCCESS_STEP } from '../ApplicationManagerModal.util';
import { getIsOnlyAdmin } from '../../../utils/businessVerification';

export default function ApplicationManagerFooter({ onClose, employees, footerProps }) {
  const { currentStep } = useWizard();
  if (currentStep === SUCCESS_STEP) {
    return null;
  }
  const isOnlyAdmin = getIsOnlyAdmin(employees);
  return (
    <DialogFooter {...footerProps}>
      <Divider />
      <ButtonGroup aria-label="Permissions Setup Actions">
        {!isOnlyAdmin && <CancelButton onClose={onClose} employees={employees} />}
        <NextButton onClose={onClose} employees={employees} />
      </ButtonGroup>
    </DialogFooter>
  );
}

ApplicationManagerFooter.propTypes = {
  onClose: PropTypes.func.isRequired,
  employees: PropTypes.array,
  footerProps: PropTypes.object,
};
